<template>
	<div class="comp">
		<div class="left">
			<div class="title">控制面板</div>
			<div class="navBox">
				<div class="navItem" :class="[platformParams.navIndex===0?'active1':'']" @click="changeNavIndex(0)">
					<img class="img" src="../../../../assets/img/yiliaoxin/img1.png">
					<div class="text">挂号记录</div>
					<div class="num">{{platformParams.medicalCount.registrationCount}}</div>
				</div>
				<div class="navItem" :class="[platformParams.navIndex===1?'active2':'']" @click="changeNavIndex(1)">
					<img class="img" src="../../../../assets/img/yiliaoxin/img2.png">
					<div class="text">病例记录</div>
					<div class="num">{{platformParams.medicalCount.caseCount}}</div>
				</div>
				<div class="navItem" :class="[platformParams.navIndex===2?'active2':'']" @click="changeNavIndex(2)">
					<img class="img" src="../../../../assets/img/yiliaoxin/img3.png">
					<div class="text">疫苗驱虫</div>
					<div class="num">{{platformParams.medicalCount.packageCount}}</div>
				</div>
				<div class="navItem" :class="[platformParams.navIndex===5?'active1':'']" @click="changeNavIndex(5)">
					<img class="img" src="../../../../assets/img/yiliaoxin/img4.png">
					<div class="text">医疗服务</div>
					<div class="num">{{platformParams.medicalCount.serviceCount}}</div>
				</div>
				<div class="navItem" :class="[platformParams.navIndex===3?'active1':'']" @click="changeNavIndex(3)">
					<img class="img" src="../../../../assets/img/yiliaoxin/img5.png">
					<div class="text">住院记录</div>
					<div class="num">{{platformParams.medicalCount.inhospitalCount}}</div>
				</div>
				<div class="navItem" :class="[platformParams.navIndex===4?'active2':'']" @click="changeNavIndex(4)">
					<img class="img" src="../../../../assets/img/yiliaoxin/img6.png">
					<div class="text">用药记录</div>
					<div class="num">{{platformParams.medicalCount.casePharmacyCount}}</div>
				</div>
			</div>
		</div>
		<div class="right">
			<div v-if="platformParams.navIndex===0" class="title">挂号记录</div>
			<div v-if="platformParams.navIndex===1" class="title">病例记录</div>
			<div v-if="platformParams.navIndex===2" class="title">疫苗驱虫</div>
			<div v-if="platformParams.navIndex===5" class="title">医疗服务</div>
			<div v-if="platformParams.navIndex===3" class="title">住院记录</div>
			<div v-if="platformParams.navIndex===4" class="title">用药记录</div>
			<!-- <div v-if="platformParams.navIndex===6" class="title">待出院</div>
			<div v-if="platformParams.navIndex===7" class="title">待完成病例</div>
			<div v-if="platformParams.navIndex===8" class="title">疫苗驱虫</div>
			<div v-if="platformParams.navIndex===9" class="title">待接诊</div>
			<div v-if="platformParams.navIndex===10" class="title">诊疗中</div> -->
			<!-- 挂号 -->
			<div v-if="platformParams.navIndex===0" class="tables">
				<el-table :data="tableData" style="width: 100%" height="100%">
					<el-table-column label="单号" width="160">
						<template slot-scope="props">
							<div>{{props.row.recordId}}</div>
						</template>
					</el-table-column>
					<el-table-column label="宠物" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.petName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="品种" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.typeName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="宠物性别" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.sex}}</div>
						</template>
					</el-table-column>
					<el-table-column label="医生" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.doctorName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="科室" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.departmentName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="金额" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.totalMoney}}</div>
						</template>
					</el-table-column>
					<el-table-column label="时间" min-width="50">
						<template slot-scope="props">
							<div>{{$public.FTime(props.row.createTime,'YYYY-MM-DD HH:mm')}}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="60">
						<template slot-scope="props">
							<el-button type="text" size="mini" @click="see_jiezhen(props.row)">
								查看
							</el-button>
							<template slot-scope="props">
								<el-button
									v-show="$buttonAuthority('yewu-yiliaoxin-jiezhen')"
									v-if="props.row.status==1&&(!props.row.doctorId||userInfo.staffId===props.row.doctorId)"
									type="text" @click="jiezhen(props.row)" size="mini">
									接诊
								</el-button>
								<el-button
								v-show="$buttonAuthority('yewu-yiliaoxin-jiezhen')"
									v-if="props.row.status==1&&(props.row.doctorId&&userInfo.staffId!==props.row.doctorId)"
									type="text" disabled size="mini">
									接诊
								</el-button>
								<el-button
								v-show="$buttonAuthority('yewu-yiliaoxin-editjiezhen')"
									v-if="props.row.status=='2'"
									type="text" @click="toBingliEdit_jiezhen(props.row)" size="mini">
									编辑
								</el-button>
								<el-button
								v-show="$buttonAuthority('yewu-yiliaoxin-del')"
									v-if="props.row.status!=3"
									type="text" @click="delJie_jiezhen(props.row)" size="mini">
									删除
								</el-button>
							</template>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 病例记录 -->
			<div v-if="platformParams.navIndex===1" class="tables">
				<el-table :data="tableData" style="width: 100%" height="100%">
					<el-table-column label="单号" min-width="50">
						<template slot-scope="props">
							<span>{{props.row.caseNumber}}</span>
							<span v-if="props.row.oneSelf" style="color:rgb(253, 78, 78)"> (自用)</span>
							<span v-if="props.row.petRights===1" style="color:rgb(253, 78, 78)"> (百天保障)</span>
							<span v-if="props.row.petRights===2" style="color:rgb(253, 78, 78)"> (万元医疗)</span>
						</template>
					</el-table-column>
					<el-table-column label="宠物" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.petName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="品种" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.typeName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="年龄" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.birthDay&&props.row.birthDay.length>4?($public.FAge(new Date(props.row.birthDay).getTime())[0]+'岁'+$public.FAge(new Date(props.row.birthDay).getTime())[1]+'月'):''}}</div>
						</template>
					</el-table-column>
					<el-table-column label="医生" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.doctorName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="病例日期" min-width="50">
						<template slot-scope="props">
							{{$public.FTime(props.row.caseDate,'YYYY-MM-DD')}}
						</template>
					</el-table-column>
					<el-table-column label="检测" min-width="50">
						<template slot-scope="props">
							<div style="color:#FD4E4E">{{props.row.isInspect==0?'未检测':''}}</div>
							<div style="color:#18A44C">{{props.row.isInspect==1?'已检测':''}}</div>
						</template>
					</el-table-column>
					<el-table-column label="支付状态" min-width="50">
						<template slot-scope="props">
							<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
							<div style="color:#FD4E4E" v-else>未支付</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="50">
						<template slot-scope="props">
							<el-button type="text" size="mini" @click="see_bingli(props.row)">查看</el-button>
							<el-button 	v-show="$buttonAuthority('yewu-yiliaoxin-editbingli')" type="text" @click="edit_bingli(props.row)" size="mini">编辑</el-button>
							<el-button 	v-show="$buttonAuthority('yewu-yiliaoxin-delbingli')" v-if="props.row.isPay==false" type="text" @click="del_bingli(props.row)" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 疫苗驱虫记录 -->
			<div v-if="platformParams.navIndex===2" class="tables">
				<el-table :data="tableData" style="width: 100%" height="100%">
					<el-table-column label="单号" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.id}}</div>
						</template>
					</el-table-column>
					<el-table-column label="类别" min-width="50">
						<template slot-scope="props">
							<span v-if="props.row.serviceTypeId===1">疫苗</span>
							<span v-if="props.row.serviceTypeId===2">驱虫</span>
						</template>
					</el-table-column>
					<el-table-column label="宠物" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.petName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="品种" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.typeName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="套餐名称" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.servicePackageName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="下次计划时间" min-width="50">
						<template slot-scope="props">
							<div v-if="props.row.payType===2" style="color:#BB6508">
								{{$public.FTime(props.row.planNextDate,'YYYY-MM-DD')}}<br>{{props.row.serviceStatus===2?'已失效':''}}
							</div>
							<div v-else>
								{{$public.FTime(props.row.planNextDate,'YYYY-MM-DD')}}<br>{{props.row.serviceStatus===2?'已失效':''}}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="医生" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.sex}}</div>
						</template>
					</el-table-column>
					<el-table-column label="支付状态" min-width="50">
						<template slot-scope="props">
							<span v-if="props.row.isPay===false" style="color:#FD4E4E">待支付</span>
							<span v-if="props.row.isPay===true" style="color:#18A44C">已支付</span>
						</template>
					</el-table-column>
					<el-table-column label="完成情况" min-width="50">
						<template slot-scope="props">
							<span style="color:#18A44C">{{props.row.completeCount}}</span>/<span>{{props.row.planCount}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="50">
						<template slot-scope="props">
							<el-button type="text" size="mini" @click="see_ymqc(props.row)">查看</el-button>
							<el-button v-show="$buttonAuthority('yewu-yiliaoxin-editquchong')" type="text" @click="edit_ymqc(props.row)" size="mini">编辑</el-button>
							<el-button v-show="$buttonAuthority('yewu-yiliaoxin-delquchong')" type="text" @click="del_ymqc(props.row)" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 医疗服务记录 -->
			<div v-if="platformParams.navIndex===5" class="tables">
				<el-table :data="tableData" style="width: 100%" height="100%">
					<el-table-column label="单号" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.id}}</div>
						</template>
					</el-table-column>
					<el-table-column label="宠物" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.petName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="品种" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.typeName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="套餐名称" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.medicalServiceName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="支付状态" min-width="50">
						<template slot-scope="props">
							<span style="color:#FD4E4E" v-if="props.row.isPay==0">未支付</span>
							<span style="color:#18A44C" v-if="props.row.isPay==1">已支付</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="50">
						<template slot-scope="props">
							<el-button type="text" size="mini" @click="see_ylfw(props.row)">查看</el-button>
							<el-button v-show="($buttonAuthority('yewu-yiliaoxin-edityiliao'))&&props.row.serviceStatus!==2" type="text" @click="edit_ylfw(props.row)" size="mini">编辑</el-button>
							<el-button v-show="($buttonAuthority('yewu-yiliaoxin-delyiliao'))&&props.row.serviceStatus!==2" type="text" @click="del_ylfw(props.row)" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 住院记录 -->
			<div v-if="platformParams.navIndex===3" class="tables">
				<el-table :data="tableData" style="width: 100%" height="100%">
					<el-table-column label="单号" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.id}}</div>
						</template>
					</el-table-column>
					<el-table-column label="宠物" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.petName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="品种" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.typeName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="经办人" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.handlerName}}</div>
						</template>
					</el-table-column>
					<el-table-column label="住院起始日期" min-width="50">
						<template slot-scope="props">
							{{$public.FTime(props.row.beginDate,'YYYY/MM/DD')}}-{{$public.FTime(props.row.endDate,'YYYY/MM/DD')}}
						</template>
					</el-table-column>
					<el-table-column label="住院时间" min-width="50">
						<template slot-scope="props">
							<div>{{props.row.inHospitalDuration}}</div>
						</template>
					</el-table-column>
					<el-table-column label="住院情况" min-width="50">
						<template slot-scope="props">
							<div v-if="props.row.payInfo.payCount===0">
								<div style="color:red">未支付</div>
							</div>
							<div v-else>
								<div style="color:#18A44C">{{props.row.status==1?'住院中':''}}</div>
								<div style="color:#B7B7B7">{{props.row.status==2?'已离院':''}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="状态" min-width="50">
						<template slot-scope="props">
							<span v-if="props.row.consumeMoney>props.row.deposit" style="color:red">已欠费</span>
							<span v-else>
								<span v-if="props.row.payInfo&&props.row.payInfo.payCount==0" style="color:#B05B12">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
								<span v-if="props.row.payInfo&&props.row.payInfo.payCount>0" style="color:#18A44C">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="50">
						<template slot-scope="props">
							<el-button type="text" size="mini" @click="see_zhuyuan(props.row)">查看</el-button>
							<el-button
							v-show="$buttonAuthority('yewu-yiliaoxin-editzhuyuan')"
							v-if="props.row.status==1"
							type="text" @click="edit_zhuyuan(props.row)" size="mini">编辑</el-button>
							<el-button
							v-show="$buttonAuthority('yewu-yiliaoxin-delzhuyuan')"
							v-if="props.row.status!=2"
							type="text" @click="del_zhuyuan(props.row)" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 用药记录 -->
			<div v-if="platformParams.navIndex===4" class="tables">
				<yaofangComp></yaofangComp>
			</div>
			<!-- /////////////////////////////////////////////////// -->
			<div class="pageBox" v-if="platformParams.navIndex!==4">
				<page style="padding:10px 0;" :total="page.total" :page="page.page" :pageSize="page.pageSize" @change="changePage"></page>
			</div>
		</div>
		<el-dialog title="" :visible.sync="dialogJiezhen_state" width="30%">
			<div>
				<el-form ref="form" label-width="80px">
					<el-form-item label="接诊医生: ">
						<div class="xmjBox">
							<div class="xmjItem" :class="curDoctor===item.userId?'active':''" @click="curDoctor = item.userId" v-for="(item) in doctorList" :key="item.userId">
								{{item.userName}}
							</div>
						</div>
						<!-- <el-select v-model="curDoctor" placeholder="请选择" size="mini">
							<el-option v-for="item in doctorList" :key="item.userId" :label="item.userName" :value="item.userId"> </el-option>
						</el-select> -->
					</el-form-item>
				</el-form>
				<div style="font-size: 16px;padding-left:10px;padding-bottom: 10px;">确定要用以上医生接诊吗？</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogJiezhen_state = false" size="mini">取 消</el-button>
				<el-button type="primary" @click="submit_jiezhen" size="mini">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import yaofangComp from "./platform_list_yaofang.vue"
	export default {
		components:{page,yaofangComp},
		data(){
			return{
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// 接诊
				curRow:null,
				dialogJiezhen_state: false,
				doctorList:[],
				curDoctor:'',
			}
		},
		computed:{
			loginInfo(){
				return this.$store.state.userInfo
			},
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
			platformParams(){
				return this.$store.state.yiliaoxin.platformParams;
			},
		},
		watch:{
			// platformParams:{
			// 	handler(n){
			// 		let navIndex = n.navIndex
			// 		if(navIndex===0){ 
			// 			this.page.page=1
			// 			this.getGuahaoList()
			// 		}else if(navIndex===1){
			// 			this.page.page=1
			// 			this.getBingliList()
			// 		}else if(navIndex===2){
			// 			this.page.page=1
			// 			this.getYmqcList()
			// 		}else if(navIndex===5){
			// 			this.page.page=1
			// 			this.getYlfwList()
			// 		}else if(navIndex===3){
			// 			this.page.page=1
			// 			this.getZhuyuanList()
			// 		}
			// 		// else if(navIndex===4){
			// 		// 	this.page.page=1
			// 		// 	this.getYaofangList()
			// 		// }
			// 	},
			// 	deep:true,
			// },
			userInfo:{
				handler(n,o){
					if(n._id!==o._id){
						this.$store.dispatch('yiliaoxin/get_medicalCount',n._id)
						this.changePage(1)
					}
				},
				deep:true,
			}
		},
		mounted(){
			if(!this.$public.isNull(this.userInfo._id)){
				this.$store.dispatch('yiliaoxin/get_medicalCount',this.userInfo._id)
			}
			
			if(this.$store.state.yiliaoxin.router.length===0){
				this.$store.commit("yiliaoxin/add_router",{name:'工作台',data:this.platformParams})
			}
			this.page = this.platformParams.initialDataOflist.page||this.page;
			this.changePage(this.page.page)
		},
		methods: {
			// 查看
			see_jiezhen(row){
				let obj = this.$store.state.yiliaoxin.jiezhenParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_jiezhenParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'接诊')
				this.$store.commit("yiliaoxin/add_router",{name:'接诊',data:obj})
			},
			see_bingli(row){
				let obj = this.$store.state.yiliaoxin.bingliParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_bingliParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'病例')
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:obj})
			},
			see_ymqc(row){
				let obj = this.$store.state.yiliaoxin.ymqcParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_ymqcParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'疫苗驱虫')
				this.$store.commit("yiliaoxin/add_router",{name:'疫苗驱虫',data:obj})
			},
			see_ylfw(row){
				let obj = this.$store.state.yiliaoxin.ylfwParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_ylfwParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'医疗服务')
				this.$store.commit("yiliaoxin/add_router",{name:'医疗服务',data:obj})
			},
			see_zhuyuan(row){
				let obj = this.$store.state.yiliaoxin.zhuyuanParams
				obj.curRow = row
				obj.type = 'see'
				this.$store.commit("yiliaoxin/set_zhuyuanParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'住院')
				this.$store.commit("yiliaoxin/add_router",{name:'住院',data:obj})
			},
			// 编辑                  医生接诊在下面
			toBingliEdit_jiezhen(row){
				let obj = this.$store.state.yiliaoxin.bingliParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_bingliParams",obj)
				this.$store.commit('yiliaoxin/set_curBusiness','病例')
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:obj})
			},
			edit_bingli(row){
				let obj = this.$store.state.yiliaoxin.bingliParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_bingliParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'病例')
				this.$store.commit("yiliaoxin/add_router",{name:'病例',data:obj})
			},
			edit_ymqc(row){
				let obj = this.$store.state.yiliaoxin.ymqcParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_ymqcParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'疫苗驱虫')
				this.$store.commit("yiliaoxin/add_router",{name:'疫苗驱虫',data:obj})
			},
			edit_ylfw(row){
				let obj = this.$store.state.yiliaoxin.ylfwParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_ylfwParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'医疗服务')
				this.$store.commit("yiliaoxin/add_router",{name:'医疗服务',data:obj})
			},
			edit_zhuyuan(row){
				let obj = this.$store.state.yiliaoxin.zhuyuanParams
				obj.curRow = row
				obj.type = 'edit'
				this.$store.commit("yiliaoxin/set_zhuyuanParams",obj)
				this.$store.commit("yiliaoxin/set_curBusiness",'住院')
				this.$store.commit("yiliaoxin/add_router",{name:'住院',data:obj})
			},
			// 删除
			delJie_jiezhen(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/Registration/Delete', {recordId:row.recordId}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getGuahaoList()
						}
					})
				})
			},
			del_bingli(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/Case/Delete', {caseNumber:row.caseNumber}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getBingliList()
						}
					})
				})
			},
			del_ymqc(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/MedicalPackage/Delete', {serviceId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getYmqcList()
						}
					})
				})
			},
			del_ylfw(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/MedicalService/Delete', {serviceId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getYlfwList()
						}
					})
				})
			},
			del_zhuyuan(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete('/api/InHospital/Delete', {inHospitalId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getZhuyuanList()
						}
					})
				})
			},
			changeNavIndex(i){
				this.platformParams.navIndex = i
				this.$store.commit("yiliaoxin/set_platformParams",this.platformParams)
				let navIndex = i
				if(navIndex===0){ 
					this.page.page=1
					this.getGuahaoList()
				}else if(navIndex===1){
					this.page.page=1
					this.getBingliList()
				}else if(navIndex===2){
					this.page.page=1
					this.getYmqcList()
				}else if(navIndex===5){
					this.page.page=1
					this.getYlfwList()
				}else if(navIndex===3){
					this.page.page=1
					this.getZhuyuanList()
				}
				// else if(navIndex===4){
				// 	this.page.page=1
				// 	this.getYaofangList()
				// }
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				let navIndex = this.platformParams.navIndex
				if(navIndex===0){
					this.getGuahaoList()
				}else if(navIndex===1){
					this.getBingliList()
				}else if(navIndex===2){
					this.getYmqcList()
				}else if(navIndex===5){
					this.getYlfwList()
				}else if(navIndex===3){
					this.getZhuyuanList()
				}
				// else if(navIndex===4){
				// 	this.getYaofangList()
				// }
			},
			getGuahaoList(){
				if(this.$public.isNull(this.userInfo._id)){
					this.page.page = 1
					this.page.total = 0
					this.tableData = []
					return ;
				}
				let params = {
					"status": 0, // 1待接诊；2已接诊；3已完成
					memberId:this.userInfo._id,
					"is_mine": false,
					"begin_time": "",
					"end_time": "",
					isPay:1,
					desc:true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": ''
				}
				let loading=this.$loading();
				this.$http.post('/api/Registration/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			getBingliList(){
				if(this.$public.isNull(this.userInfo._id)){
					this.page.page = 1
					this.page.total = 0
					this.tableData = []
					return ;
				}
				let params = {
					"departmentId": '',
					"petId": "", 
					isPay:-1, // -1不限；0未支付；1已支付
					isInspect:-1,  // -1不限；0未检测；1已检测
					isVisit:-1,  // -1不限；0未回访；1已回访
					isEnter:-1,  
					showLater:false,
					"desc": true, // true  倒序  false 正序
					"begin_time": "",
					"end_time": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": '',
					memberId:this.userInfo._id,
				}
				let loading=this.$loading();
				this.$http.post('/api/Case/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			getYmqcList(){
				if(this.$public.isNull(this.userInfo._id)){
					this.page.page = 1
					this.page.total = 0
					this.tableData = []
					return ;
				}
				let loading=this.$loading();
				let params = {
					"serviceTypeId": 0,  // 0全部 1疫苗；2驱虫;
					"payType": 1,   // 1全额支付；2计划支付 3套餐卡
					isPay:-1,            // -1全部 0未支付 1已支付
					isComplete:-1,                    //-1全部；0待完成；1已完成
					serviceStatus:-1,                    //-1全部；1正常；2失效
					petType:'',        // 犬类 猫类
					"petId": "",
					"desc": true,
					shopId:'',
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": '',
					"memberId": this.userInfo._id,
				}
				this.$http.post('/api/MedicalPackage/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			getYlfwList(){
				if(this.$public.isNull(this.userInfo._id)){
					this.page.page = 1
					this.page.total = 0
					this.tableData = []
					return ;
				}
				let params = {
					"payType": 0, // 1全额；2消费卡
					"isPay": -1,  // -1全部；0未支付；1已支付
					serviceStatus:-1,    // -1全部；1待完成；2已完成
					"petType": '',    // 猫类；犬类
					"petId": "",
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": '',
					"memberId": this.userInfo._id,
				}
				let loading=this.$loading();
				this.$http.post('/api/MedicalService/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			getZhuyuanList(){
				if(this.$public.isNull(this.userInfo._id)){
					this.page.page = 1
					this.page.total = 0
					this.tableData = []
					return ;
				}
				let params = {
					"petId": '',
					"memberId": this.userInfo._id,
					"status": 0, // 0不限；1：住院中；2：已离院
					isPay:-1,  // （-1不限：0未支付；1：已支付）
					"depositType": 0,  // (0不限；1：押金；2：余额)
					"startTime": "",
					"endTime": "",
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword":'',
				}
				let loading=this.$loading();
				this.$http.post('/api/InHospital/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
						this.replaceRouter()
					}
				})
			},
			replaceRouter(){
				this.platformParams.initialDataOflist = {
					page:this.page,
				}
				this.$store.commit("yiliaoxin/set_platformParams",JSON.parse(JSON.stringify(this.platformParams)))
				this.$store.commit("yiliaoxin/replace_router",{name:'工作台',data:JSON.parse(JSON.stringify(this.platformParams))})
			},
			// 接诊
			jiezhen(row){
				this.curRow = row;
				let curDoctor = ''
				for(let i=0;i<this.doctorList.length;i++){
					if(this.doctorList[i].userId === this.userInfo.staffId){
						curDoctor = this.userInfo.staffId;
					}
				}
				this.curDoctor = curDoctor;
				this.dialogJiezhen_state = true;
				this.getDoctorList()
			},
			submit_jiezhen(){
				if(this.$public.isNull(this.curDoctor)){
					this.$message({
						message: '请选择接诊医生',
						type: 'error'
					});
					return ;
				}
				let params = {
					recordId:this.curRow.recordId,
					doctorId:this.curDoctor,
					doctorName:this.$public.getMatchingItem(this.doctorList,'userId',this.curDoctor).userName,
				}
				this.$http.get('/api/Case/ReceptionCase', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '接诊成功',
							type: 'success'
						});
						this.dialogJiezhen_state = false;
						this.getGuahaoList()
						
						let obj = this.$store.state.yiliaoxin.bingliParams
						obj.curRow = res.data
						obj.type = 'edit'
						this.$store.commit("yiliaoxin/set_bingliParams",this.bingliParams)
						this.$store.commit('yiliaoxin/set_curBusiness','病例')
						this.$store.commit("yiliaoxin/add_router",{name:'病例',data:obj})
					}
				})
			},
			getDoctorList() {
				// let params = {
				// 	"date": '', // 10位时间戳
				// }
				// this.$http.get('/api/Registration/DutyForDay', params).then(res => {
				// 	if (res.code == 0) {
				// 		this.doctorList = res.data;
				// 	}
				// })
				let params = {
					"pageIndex": 1,
					"pageSize": 100,
					"keyword": "",
					"shopId": this.$store.state.shopId,
					"position": "医生",
					"status": '',
				}
				this.$http.post(process.env.VUE_APP_Url_8000 +'/api/staffinfo/list', params).then(res => {
					if (res.code == 0) {
						let d = res.data.data;
						this.doctorList = []
						for(let i=0;i<d.length;i++){
							this.doctorList.push({
								companyId: "",
								departments: null,
								id: '',
								introduce: "",
								scheduleDate: "",
								shopId: '',
								typeId: '',
								userId: d[i]._id,
								userName: d[i].basic_info.real_name,
							})
						}
					}
				})
			},
		},
		// beforeDestroy(){
		// 	this.platformParams.initialDataOflist = {
		// 		page:this.page,
		// 	}
		// 	this.$store.commit("yiliaoxin/set_platformParams",JSON.parse(JSON.stringify(this.platformParams)))
		// },
	}
</script>
<style scoped lang="scss">
	.comp{
		height: 100%;display: flex;
		.left{
			width:192px;border-radius: 12px;background-color: #fff;padding:0 0px;box-sizing: border-box;margin-right: 16px;
			.title{
				font-size: 18px;color:$fontColor;padding:16px 16px;font-weight: 600;
			}
			.navBox{
				padding-top:20px;
				.navItem{
					border-bottom: 1px solid #F2F2F2;padding:24px 16px;display: flex;cursor: pointer;box-sizing: border-box;
					.img{
						width:48px;height: 48px;margin-right: 12px;
					}
					.text{
						font-size: 13px;color:$fontColor;line-height: 48px;width:88px;font-weight: bold;
					}
					.num{
						font-size: 15px;color:$fontColor;font-weight: bold;float: right;line-height: 48px;
					}
					&.active1{
						background: linear-gradient(270deg, #FCFDFF 0%, #F0F2FF 100%);border-left: 2px solid #8DA2FF;
						.text{
							color:#8DA2FF;
						}
						.num{
							color:#8DA2FF;
						}
					}
					&.active2{
						background: linear-gradient(274deg, rgba(255, 253, 244, 0.44) 0%, rgba(255, 243, 209, 0.6) 100%);border-left: 2px solid $mainColor;
						.text{
							color:$mainColor;
						}
						.num{
							color:$mainColor;
						}
					}
				}
			}
		}
		.right{
			width:calc(100% - 208px);box-sizing: border-box;border-radius: 12px;background-color: #fff;box-sizing: border-box;
			.title{
				font-size: 18px;color:$fontColor;padding:16px 16px;font-weight: 600;
			}
			.tables{
				height: calc(100% - 102px);
				.tabLine{
					height:60px;padding:16px 20px 12px;box-sizing: border-box;display: flex;justify-content: space-between;
					.tabLineL{
						display: flex;
						.tabItem{
							width:90px;text-align: center;line-height: 32px;border-radius: 19px;background-color: #f7f7f7;color:#73737B;font-size: 14px;margin-right: 20px;border:1px solid transparent;cursor: pointer;
							font-weight: bold;
							&.active{
								color:$mainColor;background-color: #FFF9F3;border-color:$mainColor;
							}
						}
					}
					.tabLineR{
						
					}
				}
			}
			.pageBox{
				
			}
		}
	}
</style>
